import React, {useState} from 'react';
import { connect } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import {agregarNota,eliminarNota} from "../../redux/actions/prestamoActions"
import {useHistory} from "react-router-dom";
import Strings from "../../assets/strings";

import {
  Typography,
  Dialog,
  DialogContent,
  Button,
  IconButton,
  Divider,
  useMediaQuery,
} from '@mui/material';
import {formatDate, hasPermissionTo, PERSMISOS} from "../../helpers";
import {LoadingProgress,TopBarDialog} from "../../components";
import {Close} from '@mui/icons-material';

const useStyles = makeStyles(theme => ({
  content:{
    padding: theme.spacing(2),
    "& p":{
      margin: "2px 0px 8px",
    }
  },
  contTextArea:{
    position: "relative",

    "& textarea":{
      padding: theme.spacing(1)+" "+theme.spacing(2),

      display: "block",
      width: "100%",
      resize: "none",
      border: "none",
      outline: "none",
      boxSizing: "border-box",
      height: 33,
      transition: "all 100ms",
    },

    "& .addCont":{
      display: "flex",
      justifyContent: "flex-end",
      padding: "0px 16px",
    }
  },
  item:{
    position: "relative",
    borderBottom: "1px solid #c9c9c9",
    marginBottom: 8,
    "&:hover button":{
      display:"block",
    },
    "& button":{
      display:"none",
      position: "absolute",
      right: 0,
    }
  }
}));
function NotasPrestamo({notas,isPending,preId,...props}){
  let history = useHistory();
  const classes = useStyles();
  const smVewport = useMediaQuery((theme)=>theme.breakpoints.down('md'));
  const [state, setState] = useState({prnNota:""});

  const handleChange = e => {
    const {value,name} = e.target;
    setState({...state,[name]:value});
  };
  const submit = e => {
    props.agregarNota({...state,preId});
    setState({prnNota:""});
  };
  return (
      <Dialog fullScreen={smVewport} open={true} fullWidth maxWidth={"xs"} onClose={()=>history.goBack()}>
        <TopBarDialog title={Strings.notas} onClose={()=>history.goBack()} nofullScreen/>
        <DialogContent className={classes.content}>
          {isPending && <LoadingProgress vh={false} />}
          {notas && notas.map(nota=>
              <div key={nota.prnId} className={classes.item} >
                {hasPermissionTo(PERSMISOS.prestamosEliminarNotas) &&
                  <IconButton onClick={()=>props.eliminarNota(nota.prnId)} size={"small"}><Close fontSize={"small"} className={"text-red"}/></IconButton>
                }
                <Typography variant={"caption"}>{formatDate(nota.prnFecha)}</Typography>
                <p>{nota.prnNota}</p>
              </div>
          )}
        </DialogContent>
        {state.prnNota && <Divider/>}
        {hasPermissionTo(PERSMISOS.prestamosCrearNotas) &&
          <div className={classes.contTextArea}>
            <textarea placeholder={Strings.agregar+" "+Strings.notas} value={state.prnNota} name="prnNota"
                      onChange={handleChange}
                     maxLength="256"
            />

            {state.prnNota &&
            <div className="addCont">
              <Button size={"small"} color={"primary"} onClick={submit}>{Strings.agregar}</Button>
            </div>
            }
          </div>
        }
      </Dialog>
  );
}
const mapStateToprops = (state) => ({
  preId:state.prestamos.byId.preId,
  notas:state.prestamos.byId.notas || [],
  isPending: state.prestamos.isPending,
});
export default connect(mapStateToprops,{agregarNota,eliminarNota})(NotasPrestamo);

